import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { TrophyIcon, CheckCircleIcon } from 'lucide-react';
export function Results() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  const results = [{
    name: 'Chinedu',
    exam: 'TEF Exam',
    title: 'Épreuves QCM',
    tests: [{
      name: 'Compréhension orale',
      score: '547/699',
      level: 'C1'
    }, {
      name: 'Compréhension écrite',
      score: '502/699',
      level: 'C1'
    }]
  }, {
    name: 'Chinedu',
    exam: 'TEF Exam',
    title: "Épreuves d'expression",
    tests: [{
      name: 'Expression orale',
      score: '13/20',
      level: 'B2'
    }, {
      name: 'Expression écrite',
      score: '10/20',
      level: 'B2'
    }]
  }];
  const secondResult = [{
    name: 'Chantal',
    exam: 'TCF Exam',
    title: 'Épreuves QCM',
    tests: [{
      name: 'Compréhension orale',
      score: '547/699',
      level: 'C1'
    }, {
      name: 'Compréhension écrite',
      score: '646/699',
      level: 'C2'
    }]
  }, {
    name: 'Chantal',
    exam: 'TCF Exam',
    title: "Épreuves d'expression",
    tests: [{
      name: 'Expression orale',
      score: '13/20',
      level: 'B2'
    }, {
      name: 'Expression écrite',
      score: '11/20',
      level: 'B2'
    }]
  }];
  return <section className="py-24 bg-gradient-to-br from-slate-50 to-white" data-id="element-346">
      <div className="max-w-7xl mx-auto px-6" data-id="element-347">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 50
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-348">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-349">
            <TrophyIcon className="text-orange-600" size={40} data-id="element-350" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-351">
            Proven <span className="text-green-600" data-id="element-352">Results</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-353">
            Real exam scores from our students achieving certification success
          </p>
        </motion.div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-354">
          {/* Chinedu's Results */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8
        }} className="bg-white rounded-3xl p-8 shadow-xl" data-id="element-355">
            <div className="flex items-center gap-3 mb-6" data-id="element-356">
              <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center" data-id="element-357">
                <CheckCircleIcon className="text-white" size={24} data-id="element-358" />
              </div>
              <div data-id="element-359">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-360">
                  {results[0].name}
                </h3>
                <p className="text-slate-600" data-id="element-361">{results[0].exam}</p>
              </div>
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gthJo1UKnF9SGG3bUGHKWv/WhatsApp_Image_2025-10-23_at_21.19.22_2f8d7c78.jpg" alt="Chinedu TEF Results" className="w-full rounded-xl mb-6" data-id="element-362" />
            {results.map((section, idx) => <div key={idx} className="mb-6" data-id="element-363">
                <h4 className="text-lg font-semibold text-slate-700 mb-4" data-id="element-364">
                  {section.title}
                </h4>
                <div className="space-y-3" data-id="element-365">
                  {section.tests.map((test, testIdx) => <div key={testIdx} className="flex items-center justify-between p-4 bg-slate-50 rounded-lg" data-id="element-366">
                      <span className="text-slate-700" data-id="element-367">{test.name}</span>
                      <div className="flex items-center gap-4" data-id="element-368">
                        <span className="font-semibold text-slate-900" data-id="element-369">
                          {test.score}
                        </span>
                        <span className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-370">
                          {test.level}
                        </span>
                      </div>
                    </div>)}
                </div>
              </div>)}
          </motion.div>
          {/* Chantal's Results */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 shadow-xl" data-id="element-371">
            <div className="flex items-center gap-3 mb-6" data-id="element-372">
              <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center" data-id="element-373">
                <CheckCircleIcon className="text-white" size={24} data-id="element-374" />
              </div>
              <div data-id="element-375">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-376">
                  {secondResult[0].name}
                </h3>
                <p className="text-slate-600" data-id="element-377">{secondResult[0].exam}</p>
              </div>
            </div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2aKfJDDUVCj3Yo1VeeW1qr/WhatsApp_Image_2025-10-23_at_21.19.23_b053d72b.jpg" alt="Chantal TCF Results" className="w-full rounded-xl mb-6" data-id="element-378" />
            {secondResult.map((section, idx) => <div key={idx} className="mb-6" data-id="element-379">
                <h4 className="text-lg font-semibold text-slate-700 mb-4" data-id="element-380">
                  {section.title}
                </h4>
                <div className="space-y-3" data-id="element-381">
                  {section.tests.map((test, testIdx) => <div key={testIdx} className="flex items-center justify-between p-4 bg-slate-50 rounded-lg" data-id="element-382">
                      <span className="text-slate-700" data-id="element-383">{test.name}</span>
                      <div className="flex items-center gap-4" data-id="element-384">
                        <span className="font-semibold text-slate-900" data-id="element-385">
                          {test.score}
                        </span>
                        <span className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-386">
                          {test.level}
                        </span>
                      </div>
                    </div>)}
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}